jQuery(function ($) {
	const base = "growl-page-review";

	if ($(`.${base}__image-link`).length) {
		new SimpleLightbox(`.${base}__image-link`);
	}
});
